import React from "react";
// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import Table from '../widgets/tables/Table';
import Loading from "../components/Loading";
import getFatture from "../services/getFatture";
import deleteFattura from "../services/deleteFattura";
import ImportExcelDialog from "../widgets/ImportExcelDialog";
import getSpese from "../services/getSpese";
import moment from "moment";
import deleteSpesa from "../services/deleteSpesa";
import getUsciteForFattura from "../services/getUsciteForFattura";
import { Button, Card, Checkbox, TextField } from "@material-ui/core";
import { Stack } from "@mui/system";
import Utils from "../utils/utils";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });
export default class Fatture extends React.Component {

  constructor(props){
    super (props)
  
    this.state = {
        isLoading: true, 
        import: false,
        selectedFilter: 0,
        inScadenza: false,
        filteringPeriod: false,
        length: 0,
    };

  }

  async reload() {
    this.setState({ isLoading: true });
    let fatture = await getFatture(username, token);
    let spese = await getSpese(username, token);

    if (spese.length > 0) {
      spese.forEach((s, i) => {
        spese[i].ragione_sociale = s.descrizione;
        spese[i].tipo = 'Spesa n. fatturata';
      })
    }

    this.array = [...fatture, ...spese];
    this.array = this.array.sort((f1, f2) => {
      let data1 = moment(f1.data, 'DD/MM/yyyy');
      let data2 = moment(f2.data, 'DD/MM/yyyy');

      return data1.isBefore(data2);
    })
    
    this.filteredArray = this.array;

    var totale = 0.0;
    this.filteredArray.forEach(f => {
      totale += parseFloat(Utils.getNumberFromString(f.importo));
    })

    this.setState({ isLoading: false, totalePeriodo: String(totale.toFixed(2)) });
    await this.updateStatoFatture();
  }

  async updateStatoFatture() {
    var ind = 0;
    for (const singleFattura of this.filteredArray) {

      let res = await getUsciteForFattura(username, token, singleFattura.id);
      let count = res.count;
      let total = singleFattura.date_disposizioni ? JSON.parse(singleFattura.date_disposizioni).length : 0;

      this.filteredArray[ind].avanzamento = parseInt(count) >= total ? 'PAGATA' : count + '/' + total;      
      ind++;
    }

    this.setState({});
  }

  promisedSetState = (newState) => new Promise(resolve => this.setState(newState, resolve));

  componentDidUpdate(h, prevState) {
    if (prevState.inScadenza !== this.state.inScadenza) {
      this.handleScadenza(this.state.inScadenza);
    }
  }

  handleScadenza(inScadenza) {

    if (!inScadenza) {
      window.location.reload(); 
    }

    let fatture = [...this.array];
    fatture = fatture.filter(f => {

      if (f.avanzamento === 'PAGATA') return false;

      let found = false;
      let scadenze = f.date_disposizioni ? JSON.parse(f.date_disposizioni) : [];
      scadenze.forEach(s => {
        if (moment(s.data, 'DD/MM/yyyy').isBetween(moment(this.state.startPeriod, 'MM/yyyy').startOf('month'), moment(this.state.endPeriod, 'MM/yyyy').endOf('month'))) found = true;
      });

      return found;
    });

    this.filteredArray = fatture;
    this.setState({ });
  }

  async componentDidMount(){

    username = cookies.get('username', { path: '/' });
    token = cookies.get('token', { path: '/' });
    
    await this.reload();
  }
  
  filterDate() {
    this.filteredArray = [];
    this.filteredArray = [...this.array].filter(a => moment(a.data, 'DD/MM/yyyy').isBetween(moment(this.state.startPeriod, 'MM/yyyy').startOf('month'), moment(this.state.endPeriod, 'MM/yyyy').endOf('month')));

    var totale = 0.0;
    this.filteredArray.forEach(f => {
      totale += parseFloat(Utils.getNumberFromString(f.importo));
    })

    this.setState({ totalePeriodo: String(totale.toFixed(2)), filteringPeriod: true });
  }

  filter(index) {

    this.filteredArray = [];
    switch (index) {
      case 0:
        this.filteredArray = this.array;
        break;
      case 1: 
        this.array.forEach(f => {
          if (f.edited === '1') this.filteredArray.push(f);
        });
        break;
      default:
        this.array.forEach(f => {
          if (f.edited === '0') this.filteredArray.push(f);
        });
        break;
    }

    var totale = 0.0;
    this.filteredArray.forEach(f => {
      totale += parseFloat(Utils.getNumberFromString(f.importo));
    })

    this.setState({ selectedFilter: index, totalePeriodo: String(totale.toFixed(2)) });
  }


  render () {

    if (this.state.isLoading)
        return <Loading />;

    const cookies = new Cookies();

    var headCells = [
      { id: 'tag', numeric: false, disablePadding: true, label: 'Tag' },
      { id: 'avanzamento', numeric: false, disablePadding: true, label: 'Pagamenti', isLoading: true },
      { id: 'ragione_sociale', numeric: false, disablePadding: true, label: 'Mittente' },
      { id: 'tipo', numeric: false, disablePadding: true, label: 'Tipologia' },
      { id: 'numero', numeric: true, disablePadding: false, label: 'Numero' },
      { id: 'data', numeric: true, disablePadding: false, label: 'Data' },
      { id: 'importo', numeric: true, disablePadding: false, label: 'Importo' },
      { id: 'pagamento', numeric: true, disablePadding: false, label: 'Met. Pagamento' },
      { id: '_', numeric: true, disablePadding: false, label: '' },
    ];  

    this.searchCols = ['ragione_sociale', 'tipo', 'numero', 'tag', 'pagamento'];



    return (
      <div id={Math.random()}>
        <PageTitle title="Fatture" button="INSERIMENTO MANUALE" secondButton="IMPORTA"
            
            onClick={() => {
            window.location.href = '/#/app/addFattura';
            }}

            onSecondClick={() => {
                this.setState({ import: true });
            }}
        />

        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', alignItems: 'center', marginBottom: 20 }}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
            <div style={{ width: 100, height: 40, border: '1px solid lightgrey', borderRadius: 5, display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', backgroundColor: this.state.selectedFilter === 0 ? 'orange' : 'transparent', marginRight: 10 }} onClick={() => this.filter(0)}>
                <p style={{ color: this.state.selectedFilter === 0 ? 'white' : 'lightgrey', fontSize: 16 }}>Tutte</p>
            </div>
            <div style={{ width: 100, height: 40, border: '1px solid lightgrey', borderRadius: 5, display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', backgroundColor: this.state.selectedFilter === 1 ? 'orange' : 'transparent', marginRight: 10 }} onClick={() => this.filter(1)}>
                <p style={{ color: this.state.selectedFilter === 1 ? 'white' : 'lightgrey', fontSize: 16 }}>Modificate</p>
            </div>
            <div style={{ width: 120, height: 40, border: '1px solid lightgrey', borderRadius: 5, display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', backgroundColor: this.state.selectedFilter === 2 ? 'orange' : 'transparent' }} onClick={() => this.filter(2)}>
                <p style={{ color: this.state.selectedFilter === 2 ? 'white' : 'lightgrey', fontSize: 16 }}>Non modificate</p>
            </div>
          </div>

          <div style={{ display: 'flex', marginLeft: -10 }}>
            <TextField
              size="small"
              variant="outlined"
              type='text'
              placeholder="MM/YYYY"
              value={this.state.startPeriod}
              style={smallInputStyle}
              onChange={(e) => {
                this.setState({ startPeriod: e.target.value });
              }}
            />

            <img src={require('../images/next.png')} alt="" style={{ width: 20, height: 20, marginTop: 18, marginLeft: 7, opacity: 0.4 }} />

            <TextField
              size="small"
              variant="outlined"
              type='text'
              placeholder="MM/YYYY"
              value={this.state.endPeriod}
              style={smallInputStyle}
              onChange={(e) => {
                this.setState({ endPeriod: e.target.value });
              }}
            />

            <Button
              onClick={async () => {
                let start = this.state.startPeriod;
                let end = this.state.endPeriod;

                if (!start || start.length !== 7 || !start.includes("/")) {
                  alert('Inserire un valore valido per l\'inizio del periodo (MM/YYYY)')
                  return
                }

                if (!end || end.length !== 7 || !end.includes("/")) {
                  alert('Inserire un valore valido per la fine del periodo (MM/YYYY)')
                  return
                }

                this.filterDate();
              }}
              style={{ height: 38, marginTop: 9, marginLeft: 10 }}
              variant="contained"
              color="secondary">Aggiorna</Button>

          </div>
        </div>
        { this.state.filteringPeriod && (
          <Stack direction='row' justifyContent={'flex-end'} style={{ width: '100%', marginTop: -20, marginBottom: 20 }}>
              <Checkbox key={Math.random()} checked={this.state.inScadenza} onChange={() => this.setState({ inScadenza: !this.state.inScadenza }) } />
              <p style={{ marginTop: 15 }}>Filtra per "In scadenza nel periodo"</p>
          </Stack>
        )}

        <Card style={{ backgroundColor: 'white', display: 'flex', flexDirection: 'row', padding: 15, marginBottom: 30, boxShadow: 'none' }}>
              <h4>Totale nel periodo:</h4>
              <h3 style={{ marginLeft: 10 }}>{Utils.getNumberString(this.state.totalePeriodo)} €</h3>
        </Card>

        <Table key={this.state.length} fatture headCells={headCells} searchCols={this.searchCols} rows={this.filteredArray} sortByDate order={'desc'} sortBy={5}

            onEventFatturaClick={(isSpesa, row) => {
              if (!isSpesa) {
                cookies.set('fattura', row, { path: '/' });
                window.location.href = '/#/app/editFattura';
              } else {
                cookies.set('spesa', row, { path: '/' });
                window.location.href = '/#/app/editSpesa';
              }
            }}

            onFattureDelete={async (isSpesa, id) => {
              if (window.confirm("Sei davvero sicuro di voler eliminare questa fattura?") == false) return;

              const cookies = new Cookies();
              const username = cookies.get('username', { path: '/' });
              const token = cookies.get('token', { path: '/' });

              if (!isSpesa) {
                await deleteFattura(username, token, id);
              } else {
                await deleteSpesa(username, token, id);
              }
              this.reload();
            }}

            onSearch={(totalePeriodo) => this.state.totalePeriodo !== totalePeriodo && this.setState({ totalePeriodo })}
        />

        {this.state.import && 
            <ImportExcelDialog credenziali={{ user: username, tok: token }} onEnd={() => this.setState({ import: false })} onFatture={(fatture) => {
                this.setState({ import: false });
                this.reload();
            }} />
        }
      </div>
    );
  }
}

const smallInputStyle = {
  borderRadius: 4,
  width: 150,
  marginLeft: 5,
  paddingTop: 9,
  paddingBottom: 9,
  paddingInline: 9,
  outlineColor: '#4A4A4A',
  outlineWidth: "thin"
}